import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ApplicationPaths, ReturnUrlType } from 'src/app/constants/authorization/api-authorization.constants';
import { AuthorizeService } from 'src/app/services/authorize/authorize.service';
import { environment } from '../../../../environments/environment';
import { PingService } from '../../../services/ping.service';
import { UserModel } from 'src/app/models/authorize/user-model';


// The main responsibility of this component is to handle the user's login process.
// This is the starting point for the login process. Any component that needs to authenticate
// a user can simply perform a redirect to this component with a returnUrl query parameter and
// let the component perform the login and return back to the return url.

interface INavigationState {
  [ReturnUrlType]: string;
}



@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

    public message = new BehaviorSubject<string | null | undefined>(null);

    constructor(
        private _authorizeService: AuthorizeService,
        private _router: Router) {
    }


    ngOnInit(): void {

        this._authorizeService.user$.subscribe(user => {
            this.message.next(user?.firstName + ", you are now logged out.  Click 'Login' to return to the login page.");
            this._authorizeService.signOut();
        })
    }

    onLogin(): void {

        this._router.navigate([ApplicationPaths.Login]);
    }
}

